var Countdown = require('countdown-js')

const _this = {

    $dom: {
        days : $('.calendar-section .days'),
        hours : $('.calendar-section .hours'),
        minutes : $('.calendar-section .minutes')
    },

    vars: {
		
	},

    init : function() {
            Countdown.timer(new Date(js_global_object.next_tour).getTime(), function(timeLeft) {
            _this.$dom.days.html(timeLeft.days);
            _this.$dom.hours.html(timeLeft.hours);
            _this.$dom.minutes.html(timeLeft.minutes);
        }, function() {
          //console.log("Countdown Finished!")
        })
    },
}

export default _this;